import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardText,
  CardTitle,
} from 'reactstrap';
import stringTable from '../../config/stringTable';

import styles from './Offer.styles.module.scss';

const oneHourInMs = 60 * 60 * 1000;
const oneDayInMs = 24 * oneHourInMs;
const englishIsTheOnlyLanguageSupported = 'en';
const wordings = stringTable[englishIsTheOnlyLanguageSupported];

const expirationDisplayText = (viewedAt) => {
  const { hour, hours } = wordings;
  const expiresInMs = (viewedAt + oneDayInMs) - Date.now();
  const expiresInH = Math.floor(expiresInMs / oneHourInMs);
  if (expiresInH > 0) return `${expiresInH} ${expiresInH > 1 ? hours : hour}`;
  return wordings['less than an hour'];
};

export default function DisplayOffer({ offer, onAccept, onDecline }) {
  const { errorType, status, viewedAt } = offer;
  if (errorType || status !== 'viewed') return null;
  return (
    <Card>
      <CardBody className={styles.card}>
        <CardTitle tag="h5">
          { wordings['Your Personal Limited Time Offer'] }
        </CardTitle>
        <CardText>
          { wordings['You have been pre-approved for a loan with'] }
          &nbsp;Wallace Finance
        </CardText>
        <CardText>
          { wordings['This offer will require you to go to their closest retail outlet to verify your identity and '
          + 'sign the required documentation.'] }
        </CardText>
        <CardText>
          { wordings['If you accept these terms please click the Accept button below before the offer expires. '
          + 'Your personal offer code will be emailed to you once you accept. '
          + 'Otherwise we will redirect you to match with another lender.'] }
        </CardText>
        <Button
          className={styles['offer-button']}
          color="success"
          onClick={onAccept}
        >
          { wordings['Accept Offer'] }
        </Button>
        <Button
          className={styles['offer-button']}
          onClick={onDecline}
        >
          { wordings['Decline Offer'] }
        </Button>
      </CardBody>
      <CardFooter>
        {wordings['This offer expires in']}
        &nbsp;
        { expirationDisplayText(viewedAt) }
        .
      </CardFooter>
    </Card>
  );
}
